import { User } from './types';
import { globalGetService } from '@/utils/globalApiServices';

export const getMe = async () => {
  const response = await globalGetService('user');
  return response?.ok ? (response.data as User) : undefined;
};
